
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/SupabaseAuthContext';
import DashboardContent from './DashboardContent';
import DashboardLayout from '@/components/dashboard/DashboardLayout';
import { useDashboardContent } from './hooks/useDashboardContent';

const DashboardPage = () => {
  const navigate = useNavigate();
  const {
    user,
    isAuthenticated,
    signOut,
    loading
  } = useAuth();
  const dashboardData = useDashboardContent();
  
  if (loading || dashboardData.isLoading) {
    return <DashboardLayout isLoading={true} onLogout={signOut}>
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      </DashboardLayout>;
  }
  
  if (!isAuthenticated) {
    navigate('/login');
    return null;
  }

  // Create a wrapper function that doesn't require parameters to match the expected prop type
  const handleExportReport = dashboardData.exportReport ? () => {
    dashboardData.exportReport('csv'); // Default to CSV format when no argument is provided
  } : undefined;
  
  return <DashboardLayout onLogout={signOut}>
      <div className="max-w-7xl px-4 sm:px-6 lg:px-8 mx-auto pl-4 md:pl-8 lg:pl-12"> {/* Added left padding classes */}
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
          <p className="text-gray-600">Welcome back, {user?.user_metadata?.first_name || user?.user_metadata?.name || 'User'}</p>
        </div>
        
        {dashboardData.user && <DashboardContent 
          user={dashboardData.user} 
          referrals={dashboardData.referrals || []} 
          points={dashboardData.points || 0} 
          referralCode={dashboardData.referralCode || ''} 
          referralLink={dashboardData.referralLink || ''} 
          reportData={dashboardData.reportData || []} 
          chartData={dashboardData.chartData || []} 
          lastMonthEarnings={dashboardData.lastMonthEarnings || 0} 
          lifetimeEarnings={dashboardData.lifetimeEarnings || 0} 
          signupDate={dashboardData.signupDate || new Date().toISOString()} 
          currentMonth={dashboardData.currentMonth || 'January'} 
          currentYear={dashboardData.currentYear || '2025'} 
          handleSendReferral={dashboardData.handleSendReferral || (() => Promise.resolve())} 
          exportReport={handleExportReport} 
        />}
      </div>
    </DashboardLayout>;
};

export default DashboardPage;
